import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";

const TOGGLE_SIZE = "22px";
const ICON_SLOT_SIZE = "20px";
const EXPANDED_ROTATION = "rotate(90deg)";
const MOBILE_BREAKPOINT = `(max-width: ${designTokens.breakpoint.md})`;

export const useVaultFolderRowStyles = makeStyles({
  item: {
    listStyleType: "none",
    margin: 0,
    padding: 0,
  },
  row: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[3],
    padding: `${designTokens.spacing[3]} ${designTokens.spacing[4]}`,
    borderTop: `1px solid ${projectIqTokens.line2}`,
    backgroundColor: projectIqTokens.card,
    [`@media ${MOBILE_BREAKPOINT}`]: {
      flexWrap: "wrap",
    },
  },
  toggleSlot: {
    width: TOGGLE_SIZE,
    flexShrink: 0,
  },
  toggleButton: {
    width: TOGGLE_SIZE,
    height: TOGGLE_SIZE,
    padding: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    border: "none",
    borderRadius: designTokens.borderRadius.sm,
    backgroundColor: "transparent",
    color: projectIqTokens.faint,
    cursor: "pointer",
    ":hover": {
      color: projectIqTokens.ink,
    },
    ":focus-visible": {
      outline: `2px solid ${projectIqTokens.teal}`,
      outlineOffset: "1px",
    },
  },
  toggleIcon: {
    fontSize: designTokens.fontSize.base,
    transition: `transform ${designTokens.transition.fast}`,
  },
  toggleIconExpanded: {
    transform: EXPANDED_ROTATION,
  },
  kindIcon: {
    width: ICON_SLOT_SIZE,
    flexShrink: 0,
    display: "flex",
    justifyContent: "center",
    fontSize: designTokens.fontSize.lg,
  },
  folderIcon: {
    color: projectIqTokens.amber,
  },
  fileIcon: {
    color: projectIqTokens.faint,
  },
  name: {
    flex: 1,
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    fontSize: designTokens.fontSize["2xs"],
    fontWeight: designTokens.fontWeight.semibold,
    color: projectIqTokens.ink,
  },
  folderName: {
    fontWeight: designTokens.fontWeight.bold,
  },
  fileCount: {
    fontWeight: designTokens.fontWeight.normal,
    fontSize: designTokens.fontSize.xxs,
    color: projectIqTokens.faint,
  },
  meta: {
    fontSize: designTokens.fontSize.xs,
    color: projectIqTokens.muted,
    whiteSpace: "nowrap",
  },
  openButton: {
    width: TOGGLE_SIZE,
    height: TOGGLE_SIZE,
    padding: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    border: "none",
    borderRadius: designTokens.borderRadius.sm,
    backgroundColor: "transparent",
    color: projectIqTokens.faint,
    fontSize: designTokens.fontSize.base,
    cursor: "pointer",
    ":hover": {
      color: projectIqTokens.ink,
    },
    ":focus-visible": {
      outline: `2px solid ${projectIqTokens.teal}`,
      outlineOffset: "1px",
    },
  },
  childList: {
    listStyleType: "none",
    margin: 0,
    padding: `0 0 0 ${designTokens.spacing[6]}`,
  },
  emptyMessage: {
    listStyleType: "none",
    // Line the text up with the icon column of the rows around it: row padding,
    // then the toggle slot and the gap that follows it.
    padding: `${designTokens.spacing[2]} ${designTokens.spacing[4]} ${designTokens.spacing[2]} calc(${designTokens.spacing[4]} + ${TOGGLE_SIZE} + ${designTokens.spacing[3]})`,
    borderTop: `1px solid ${projectIqTokens.line2}`,
    fontSize: designTokens.fontSize.xs,
    color: projectIqTokens.faint,
  },
});
